/*
 * Copyright 2024 Collaterate. All rights reserved.
 */

var detailedVersionsController = {};

$(function () {
    detailedVersionsController.open = open;
    detailedVersionsController.updateVersion = updateVersion;
    detailedVersionsController.removeVersion = removeVersion;
    detailedVersionsController.addVersion = addVersion;

    // Constants
    var VERSIONS_GRID_CONTAINER = 'versionsGridContainer';
    var VERSIONS_GRID_CONTAINER_SELECTOR = '#' + VERSIONS_GRID_CONTAINER;
    var VERSIONS_GRID_TBODY_SELECTOR = VERSIONS_GRID_CONTAINER_SELECTOR + ' tbody';
    var ADD_VERSION_BUTTON = 'addVersionLink';
    var ADD_VERSION_BUTTON_SELECTOR = '#' + ADD_VERSION_BUTTON;
    var DELETE_VERSION_BUTTON_CLASS = 'deleteVersionButton';
    var DELETE_VERSION_BUTTON_CLASS_SELECTOR = '.' + DELETE_VERSION_BUTTON_CLASS;
    var QUOTEINPUTDATA = 'QUOTEINPUTDATA';
    var VERSIONNAMEEF = 'VERSIONNAMEEF';
    var VERSION_QUANTITY_EF = 'VERSION_QUANTITY_EF';

    // Comet Action Constants
    var UPDATE_VERSION = 'UPDATE_VERSION';
    var REMOVEVERSION = 'REMOVEVERSION';
    var ADDVERSION = 'ADDVERSION';

    var maxVersions;

    function open () {
        var cquotedata = configureglobals.cquotedata;
        maxVersions = configureglobals.clpjc !== undefined ? configureglobals.clpjc.maxVersions : configureglobals.cpjc.maxVersions;

        var content = tags.div('', {
            id: VERSIONS_GRID_CONTAINER
        });

        var options = {
            showSave: false,
            showCancel: false
        };

        if (cquotedata.externallyGenerated) {
            options.width = '625px';
        }

        savePanel.open(content, options);

        generateVersionsTable();
    }

    function generateVersionsTable () {
        var cquotedata = configureglobals.cquotedata;
        var versions = cquotedata.versions;
        var $versionGridContainer = $(VERSIONS_GRID_CONTAINER_SELECTOR);
        var scrollTop = $(VERSIONS_GRID_TBODY_SELECTOR).scrollTop();

        $versionGridContainer.empty();

        var versionsTable = new JDTable({
            cssClass: 'fixedHeaderFlexTable'
        });

        if (cquotedata.externallyGenerated) {
            versionsTable.addRow(
                [{ style: 'width: 110px; margin: 5px;', tag: 'th', colspan: 2, text: 'Versions: ' + (versions == null ? 0 : versions.length) }, { style: 'width: 125px; margin: 5px;', tag: 'th', text: 'Version Name' }, { style: 'width: 125px; margin: 5px;', tag: 'th', text: 'TBG SKU' }, { style: 'width: 125px; margin: 5px;', tag: 'th', text: 'Quantity' }],
                { headerRow: true }
            );
        } else {
            versionsTable.addRow(
                [{ tag: 'th', colspan: 2, text: 'Versions: ' + (versions == null ? 0 : versions.length) + (maxVersions > 1 ? ' (Max: ' + maxVersions + ')' : '') }, { tag: 'th', cssClass: 'bulkVersionTable--doneButtonCell', text: '<button type="button" onclick="savePanel.cancelClicked()">Done</button>' }],
                { headerRow: true }
            );
        }

        if (versions != null) {
            for (var index = 0; index < versions.length; index++) {
                versionsTable.addRow(createCells(versions[index], index), { id: 'versionRow' + index });

                if (common.validation.hasJobQuoteFieldMessagesFor(VERSION_QUANTITY_EF + index)) {
                    versionsTable.addRow([{ text: common.validation.generateJobQuoteFieldMessagesFor(VERSION_QUANTITY_EF + index) }], { id: 'versionErrorRow' + index, style: 'text-align: right; padding-right: 15px;' });
                }
            }
        }

        // Adds "add version" row/link
        versionsTable.addRow([{ tag: 'td', colspan: 3, cssClass: 'bulkVersionTable--addVersionRow', text: '<a href="javascript:detailedVersionsController.addVersion()" class="link link_iconAddVersion" id="' + ADD_VERSION_BUTTON + '">add version</a>' }]);

        $versionGridContainer.html('<h3>Edit Versions</h3>' + versionsTable.generate());
        $(VERSIONS_GRID_TBODY_SELECTOR).scrollTop(scrollTop);
        updateVisibility();
    }

    function updateVersion (index) {
        var configChangeDetails = {
            context: 'updateVersion',
            category: confUtil.OPTION_CHANGE,
            value: index
        };

        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, UPDATE_VERSION, function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject(QUOTEINPUTDATA));
            growlMessages.showAll(cometRequest);
            quantityConfigureController.generateQuantity();
            generateVersionsTable();

            controller.getQuote(false, function () {
                if (configureglobals.cquotedata.externallyGenerated && common.validation.hasJobQuoteFieldMessagesFor('QUANTITYEF')) {
                    $('.versionQuantity').addClass('error');
                    $(VERSIONS_GRID_CONTAINER_SELECTOR).append(common.validation.generateJobQuoteFieldMessagesFor('QUANTITYEF'));
                }
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });

        cometRequest.addObjectId(index);
        cometRequest.addFormField(VERSIONNAMEEF + index, false, document);
        cometRequest.addFormField(VERSION_QUANTITY_EF + index, false, document);
        cometRequest.send();
    }

    function removeVersion (index) {
        var configChangeDetails = {
            context: 'removeVersion',
            category: confUtil.OPTION_CHANGE,
            value: index
        };

        configureEvents.onCalcChanged(configChangeDetails);
        confirmPanel.confirm('Are you sure you want to remove this version?', function () {
            var cometRequest = comet.newRequest(chandler, REMOVEVERSION, function (cometRequest) {
                common.setCQuoteData(cometRequest.getObject(QUOTEINPUTDATA));
                growlMessages.showAll(cometRequest);
                quantityConfigureController.generateQuantity();
                generateVersionsTable();

                controller.getQuote(false, function () {
                    configureEvents.onQuoteUpdated(configChangeDetails);
                });
            });
            cometRequest.addObjectId(index);
            cometRequest.send();
        }, null, { confirmText: 'Remove' });
    }

    function addVersion () {
        var versions = configureglobals.cquotedata.version;

        var configChangeDetails = {
            context: 'addVersion',
            category: confUtil.OPTION_CHANGE,
            value: versions == null ? 0 : versions.length - 1
        };

        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, ADDVERSION, function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject(QUOTEINPUTDATA));
            growlMessages.showAll(cometRequest);
            quantityConfigureController.generateQuantity();
            generateVersionsTable();

            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.send();
    }

    function createCells (version, index) {
        var cquotedata = configureglobals.cquotedata;

        var deleteVersion = tags.a('', 'javascript:detailedVersionsController.removeVersion(' + index + ')', {
            id: 'deleteVersion' + index,
            cssClass: 'deleteVersion ' + DELETE_VERSION_BUTTON_CLASS,
            title: 'Delete This Version',
            style: 'width: 50px;'
        });

        var deleteVersionContainer = tags.span(deleteVersion, {
            id: 'versionDelete' + index,
            cssClass: 'deleteVersion',
            style: 'width: 75px;'
        });

        if (cquotedata.externallyGenerated) {
            var nameField = forms.ef(VERSIONNAMEEF + index, version.name, {
                id: VERSIONNAMEEF + index,
                cssClass: 'configField versionName noEdit',
                style: 'width: 187px;',
                disabled: true
            });

            var versionQuantityField = forms.ef(VERSION_QUANTITY_EF + index, version.quantity, {
                id: VERSION_QUANTITY_EF + index,
                cssClass: 'configField versionQuantity' + (common.validation.hasJobQuoteFieldMessagesFor(VERSION_QUANTITY_EF + index) ? ' error' : ''),
                onblur: 'detailedVersionsController.updateVersion(' + index + ')',
                style: 'width: 188px;'
            });

            return [{ text: deleteVersionContainer }, { text: version.label }, { text: nameField }, { text: versionQuantityField }];
        }

        var nameField = forms.ef(VERSIONNAMEEF + index, version.name, {
            id: VERSIONNAMEEF + index,
            cssClass: 'configField versionName',
            onblur: 'detailedVersionsController.updateVersion(' + index + ')',
            style: 'width: 100%'
        });

        return [{ text: deleteVersionContainer }, { text: version.label }, { text: nameField }];
    }

    function updateVisibility () {
        var cquotedata = configureglobals.cquotedata;

        if (!cquotedata.externallyGenerated && cquotedata.versionCount > 2) {
            $(DELETE_VERSION_BUTTON_CLASS_SELECTOR).show();
        } else {
            $(DELETE_VERSION_BUTTON_CLASS_SELECTOR).hide();
        }

        if (!cquotedata.externallyGenerated && maxVersions > 1 && (cquotedata.versionCount != null && maxVersions > cquotedata.versionCount)) {
            $(ADD_VERSION_BUTTON_SELECTOR).show();
        } else {
            $(ADD_VERSION_BUTTON_SELECTOR).hide();
        }

        if (cquotedata.versionCount === null) {
            $.each($('.versionName'), function (index, versionNameField) {
                $(versionNameField).prop('disabled', true);
            });
        }
    }
});
